import { render, staticRenderFns } from "./DashboardTemplateForm.vue?vue&type=template&id=db2847fa"
import script from "./DashboardTemplateForm.vue?vue&type=script&lang=js"
export * from "./DashboardTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports